const sortConversationsByUnreadStatus = conversations => conversations.filter(c => c.unreadMessages === true).concat(conversations.filter(c => c.unreadMessages === false));
export default sortConversationsByUnreadStatus;
//# sourceMappingURL=sortConversationsByUnreadStatus.js.map